<!---job list -->
<div class="dashboard_bred_crumb">
    <ul>
        <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
        <li><a>Course Listing</a></li>
    </ul>
</div>

<section class="dashboard_content_sec">
    <section class="master_add_sec filterSec">

        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 20px;">
            <div class="search-container">
                <input type="text" name="search" class="search-input"
                    placeholder="Search by Course name, Company, Presenter" [formControl]="searchControl" />
                <img src="../../../../../../../assets/images/icons/search_grey.svg" alt="Search" class="search-icon" />
            </div>

            <div class="search-box">
                <button type="button" class="table-filter-btn" (click)="toggleFilter()"
                    style="display: flex; align-items: center;">
                    <img src="../../../../../assets/images2/Funnel.svg" alt="Filter" width="16" height="16"
                        style="margin-right: 5px;" />
                    Filter
                </button>
            </div>
        </div>

        <section *ngIf="openFilter" class="basic-filter openclose-filter-sec">


            <div class="filter-row">


                <div>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Type</mat-label>
                        <input matInput placeholder="Search Type" [matAutocomplete]="typeAuto"
                            (input)="onTypeInput($event.target.value)" [(ngModel)]="filterType">
                        <mat-autocomplete #typeAuto="matAutocomplete"
                            (optionSelected)="onTypeSelected($event.option.value)">
                            <mat-option *ngFor="let type of filteredCourseTypes" [value]="type.name">
                                {{ type.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <div class="dropdown-container">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Categories</mat-label>
                        <input matInput placeholder="Search Categories" [matAutocomplete]="categoryAuto"
                            (input)="onCategoryInput($event.target.value)" [(ngModel)]="filterCategory">

                        <mat-autocomplete #categoryAuto="matAutocomplete"
                            (optionSelected)="onCategorySelected($event.option.value)">
                            <mat-option *ngFor="let cat of filteredCourseCategories" [value]="cat.name">
                                {{ cat.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>


                <!-- Month Filter -->
                <div>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Date (YYYY-MM-DD)</mat-label>

                        <!-- Show selected date -->
                        <input matInput [matDatepicker]="picker" placeholder="Choose date" [(ngModel)]="selectedMonth"
                            (dateChange)="chosenDateHandler($event.value)" readonly />

                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <!-- Clear Button -->
                <div style="flex: 0 0 auto;">
                    <button mat-button class="clear-btn" type="button" (click)="clearAllFilters()">Clear</button>
                </div>
            </div>
        </section>

    </section>

    <div infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="200" (scrolled)="onScroll()">

        <div *ngIf="dataLoader" class="custom-loader custom_logo_loader no-datas">
            <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 10%;" />
        </div>

        <ng-container *ngIf="!dataLoader">
      <ng-container *ngIf="registeredCourses?.length > 0; else noData">
        <section class="master_add_sec" *ngFor="let x of registeredCourses;">
            <mat-card class="job-card" fxLayout="column" fxLayoutGap="16px">
                <!-- Row: Avatar + Content -->
                <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start">
                    <!-- Avatar -->
                    <!-- <div class="avatar">
                        <img *ngIf="x?.presented_by_image?.url" src="{{x?.presented_by_image?.url}}" alt="Avatar"
                            loading="lazy" />
                    </div> -->

                    <!-- <div class="avatar" *ngIf="x?.presenters?.length > 0; else noPresenters">
                        <swiper [config]="prsentersConfig" class="mySwiper">
                            <div *ngFor="let presenter of x?.presenters" class="swiper-slide">
                                <img *ngIf="presenter?.presented_by_image?.url" [src]="presenter.presented_by_image.url" alt="Avatar"
                                    loading="lazy" />
                            </div>
                        </swiper>
                    </div> -->


                    <div class="presenters" *ngIf="x?.presenters?.length > 0; else noPresenters">
                                <swiper [config]="prsentersConfig" class="mySwiper">
                                    <div *ngFor="let presenter of x.presenters" class="swiper-slide presenter-card">
                                        <div class="avatar">
                                            <img *ngIf="presenter?.presented_by_image?.url" [src]="presenter.presented_by_image.url"
                                                alt="Avatar" loading="lazy" />
                                        </div>
                                        <div class="presenter-name">
                                            {{ presenter.presented_by_name }}
                                        </div>
                                    </div>
                                </swiper>
                            </div>

                    <ng-template #noPresenters>
                        <div class="avatar"></div>
                    </ng-template>

                    <div fxFlex class="content-box" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
                        <!-- Top Row -->
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="top-row">
                            <div class="title" *ngIf="x?.course_name || x?.created_at">
                                <strong class="title_head" *ngIf="x?.course_name">
                                    {{ x?.course_name }}
                                </strong>
                            </div>
                            <div>
                                <span class="date" *ngIf="x?.created_at">
                                    Posted on : {{ x?.created_at | date:'dd-MM-yyyy' }}
                                </span>
                            </div>
                        </div>

                        <!-- <div *ngIf="x?.presenters?.length > 0" class="company-name">
                            <ng-container *ngFor="let presenter of x.presenters; let i = index">
                                {{ presenter.presented_by_name }} <span *ngIf="i < x.presenters.length - 1">, </span>
                            </ng-container>
                        </div> -->

                        <!-- cpd Hours -->
                        <div class="" *ngIf="x?.cpd_points">
                            CPD POINTS : {{ x?.cpd_points }}
                        </div>

                        <!-- Chips  Applicants -->
                        <div fxLayout="row"  class="chip-row">
                            <mat-chip-list class="chip-list"  *ngIf="x?.type">
                                <mat-chip>{{ x?.type }}</mat-chip>
                            </mat-chip-list>

                            <mat-chip-list *ngIf="x?.type === 'Webinar' && x?.afterwards_price > 0" class="chip-list">
                                <mat-chip *ngIf="getWebinarChip(x?.course_registered_users) === 'PENDING'"
                                    style="color: #e19200 !important; background: #ec99001a !important;">PENDING
                                </mat-chip>
                                <mat-chip *ngIf="getWebinarChip(x?.course_registered_users) === 'APPROVED'"
                                    style="color: #00934f !important; background: #00934f1a !important;"> APPROVED
                                </mat-chip>
                            </mat-chip-list>

                        <mat-chip-list *ngIf="hasCancelled(x?.course_registered_users, 'CANCELLED')" class="chip-list">
                            <mat-chip style="color: #d71313 !important; background: #d713131a !important;">
                                CANCELLED
                            </mat-chip>
                        </mat-chip-list>

                        <mat-chip-list *ngIf="hasCompleted(x?.course_registered_users)" class="chip-list">
                            <mat-chip style="color: #00934f !important; background: #00934f1a !important;">
                                COMPLETED
                            </mat-chip>
                        </mat-chip-list>

                        </div>

                        <ng-container *ngIf="x?.type === 'Webinar' && !hasCancelled(x?.course_registered_users, 'CANCELLED') ">
                        
                            <!-- Case: afterwards_price <= 0 -->
                            <div *ngIf="x?.afterwards_price <= 0; else priceCheck">
                                <div *ngIf="x?.webinar_link" class="webinar-link-container">
                                    <span class="label">Meeting Link : </span>
                                    <a [href]="x?.webinar_link" target="_blank" rel="noopener noreferrer">{{ x?.webinar_link }}</a>
                                </div>
                            </div>
                        
                            <!-- Case: afterwards_price > 0 -->
                            <ng-template #priceCheck>
                                <ng-container *ngIf="getWebinarChip(x?.course_registered_users) === 'APPROVED'; else pendingStatus">

                                    <div *ngIf="x?.webinar_link" class="webinar-link-container">
                                        <span class="label">Meeting Link : </span>
                                        <a [href]="x?.webinar_link" target="_blank" rel="noopener noreferrer">{{ x?.webinar_link }}</a>
                                    </div>
                                </ng-container>
                        
                                <ng-template #pendingStatus>
                                   <div *ngIf="x?.webinar_link" class="webinar-link-container">
                                        <span class="label">Meeting Link : </span>
                                        <span> Pending from course administrator </span>
                                    </div>
                                </ng-template>
                            </ng-template>

                            
                        
                        </ng-container>


                        <!-- <div *ngIf="x?.webinar_link" class="webinar-link-container">
                            <span class="label">Meeting Link : </span>
                            <a [href]="x?.webinar_link" target="_blank" rel="noopener noreferrer">{{
                                x?.webinar_link}}</a>
                        </div> -->
                    </div>
                </div>

                <div class="inner-divider"></div>

                <div class="" style="display: flex;flex-wrap: wrap;text-align: center;gap: 10px;"> 

                <!-- <div *ngIf="hasCompleted(x?.course_registered_users) " (click)="downloadCertificate(x)" class ="certificate-download" >
                    Download Certificate
                </div> -->
                <div *ngIf="hasCompleted(x?.course_registered_users) " (click)="downloadCertificate(x)" class ="certificate-download" >
                    Download Certificate
                </div>
<!-- 
                <div (click)="testDownloadCertificate()" class ="certificate-download" >
                   Test Download static
                </div>

                <div (click)="testFontDownloadCertificate()" class ="certificate-download" >
                   Test font Download 
                </div> -->

                <div class="view-details" fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center"
                    [routerLink]="['/learning/learning-hub-details', x.id]">
                    <span>View Details</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>
                </div>

            </mat-card>
        </section>
         </ng-container>

        <div *ngIf="loading && registeredCourses.length > 0" class="loading-more" fxLayout="row" fxLayoutAlign="center center">
            <img src="../../../../../assets/images2/loader.gif" alt="Loading more..." loading="lazy" width="80px" />
        </div>

    </ng-container>


         <ng-template #noData>
        <div class="no-data-wrapper">
          <img src="../../../../../assets/images/icons/no_tasks.svg" alt="No records illustration" class="no-data-image" />
          <div class="no-record-text"> 
           No registered courses available at the moment
          </div>
        </div>
      </ng-template>

        <!-- Show "No more courses to load" only after scrolling finishes -->
        <div *ngIf="initialLoadDone && allDataLoaded && registeredCourses.length > 0" class="text-center py-3 text-muted"
            >
           You've reached the end — no more registered courses to display
        </div>
    </div>
</section>



<!-- pdf download section  -->

<div id="certificate" class="certificate-container" style="display: none;">
  <div class="logo-container">
    <img [src]="certificateData?.logo" crossorigin="anonymous"> 
  </div>

  <hr class="header-line" />
  <div class="cpdpoints">{{ certificateData?.cpd_points }} CPD</div>

  <div class="certificate-header">
    <svg viewBox="0 30 600 80" class="curved-title">
      <path id="curve" d="M50,135 C150,30 450,30 550,135" fill="transparent"></path>
      <text>
        <textPath href="#curve" startOffset="50%" text-anchor="middle">
          Certificate of Attendance
        </textPath>
      </text>
    </svg>
    <div class="academy-text">{{ certificateData?.company_name }} certify that</div>
  </div>

  <div class="certificate-body">
    <div class="recipient-name">{{ certificateData?.first_name }} {{ certificateData?.last_name }}</div>
    <div class="certificate-text">
      has successfully attended the <span>{{ certificateData?.course_name }}</span> held from
      <span>{{ certificateData?.startDate }}</span> to <span>{{ certificateData?.endDate }}</span>,
      presented by
      <ng-container *ngFor="let p of certificateData?.presenters; let i = index">
        <span>{{ p.presented_by_name }}</span
        ><span *ngIf="i < certificateData?.presenters.length - 1">
          <ng-container *ngIf="i === certificateData?.presenters.length - 2"> and </ng-container>
          <ng-container *ngIf="i < certificateData?.presenters.length - 2">, </ng-container>
        </span>
      </ng-container>.
    </div>

    <div class="signature-section">
      <div class="signature-box" *ngFor="let p of certificateData?.presenters">
        <div class="signature-text">{{ p.presented_by_name }}</div>
        <div class="signature-line"></div>
        <div class="signature-name">{{ p.presented_by_name }}</div>
      </div>
    </div>
  </div>
</div>

